import { Box, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { AuthLayout } from "src/layouts/AuthLayout";
import { useLoginMutation } from "src/hooks/useLoginMutation";
import { LoginForm, LoginFormData } from "src/forms/LoginForm";

export function LoginPage() {
  const history = useHistory();
  const { t } = useTranslation();

  const loginMutation = useLoginMutation();

  async function handleSubmit(values: LoginFormData) {
    await loginMutation.mutateAsync(values);
    return history.push("/login-redirect");
  }

  return render();

  function render() {
    return (
      <AuthLayout>
        <StyledBox height="100%" display="flex" flexDirection="column" justifyContent="center">
          <Box pb={3}>
            <Typography variant="h3" component="h1">
              {t("label.welcome")}
            </Typography>
            <Typography variant="subtitle1" component="h1">
              {t("label.loginToContinue")}
            </Typography>
          </Box>

          <LoginForm onSubmit={handleSubmit} errors={loginMutation.error} isLoading={loginMutation.isLoading} />
        </StyledBox>
      </AuthLayout>
    );
  }
}

const StyledBox = styled(Box)`
  margin: 0 auto;

  ${({ theme }) => `
  padding: ${theme.spacing(8)};
  `}
`;
